// Bounded, memory-only snapshots. Callers clear them whenever authorization changes.
export default class CustomerHubRangeCache {
  constructor(limit = 8, maxRecords = 12000) { this.limit = limit; this.maxRecords = maxRecords; this.items = new Map() }
  clear() { this.items.clear() }
  get(key) {
    const entry = this.items.get(key)
    if (!entry) return null
    this.items.delete(key); this.items.set(key, entry)
    return entry
  }
  put(key, value, size = 1) {
    this.items.delete(key)
    if (size > this.maxRecords) return
    this.items.set(key, { value, at: Date.now(), size })
    while (this.items.size > this.limit || [...this.items.values()].reduce((sum, entry) => sum + entry.size, 0) > this.maxRecords) this.items.delete(this.items.keys().next().value)
  }
}

